import React, { useEffect, useState } from "react";
import {
  IconAlertTriangle, IconBan, IconUserOff, IconArrowsExchange,
  IconCurrencyDollarOff, IconClockExclamation, IconHourglassEmpty,
  IconMoodSad, IconReceipt2, IconCalendar, IconUsers,
} from "@tabler/icons-react";
import BlockSection, { KPISubgroup } from "./BlockSection";
import KPICard from "./KPICard";
import InsightsChart from "./InsightsChart";
import { fetchBottlenecks, exportInsightsXLSX } from "../services";

const BottlenecksBlock = ({ filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setLoading(true); setError(null);
    try {
      const d = await fetchBottlenecks(filters);
      setData(d);
    } catch (e) {
      setError("Não foi possível carregar este bloco.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); /* eslint-disable-line */ }, [filters]);

  const k = data?.kpis || {};
  const pareto = data?.charts?.loss_reasons_pareto;

  return (
    <BlockSection
      title="Onde estou perdendo dinheiro?"
      subtitle="Cancelamentos, no-shows, sessões abandonadas, deals estagnados"
      icon={IconAlertTriangle}
      color="linear-gradient(135deg, #ef4444, #dc2626)"
      loading={loading}
      error={error}
      onRetry={load}
      onExport={() => exportInsightsXLSX("bottlenecks", filters)}
    >
<KPISubgroup title="Agendamentos" icon={IconCalendar} color="#ef4444">
        <KPICard
          label="Taxa de Cancelamento"
          kpi={k.cancel_rate}
          icon={IconBan}
          color="linear-gradient(135deg, #ef4444, #dc2626)"
        />
        <KPICard
          label="Receita Perdida em Cancelamentos"
          kpi={k.lost_revenue_canceled}
          icon={IconCurrencyDollarOff}
          color="linear-gradient(135deg, #ef4444, #dc2626)"
        />
        <KPICard
          label="Taxa de No-Show"
          kpi={k.no_show_rate}
          icon={IconUserOff}
          hint="Agendamentos marcados como 'faltou' no período"
        />
        <KPICard
          label="Receita Perdida em No-Shows"
          kpi={k.lost_revenue_no_show}
          icon={IconReceipt2}
        />
        <KPICard
          label="Confirmações Pendentes"
          kpi={k.pending_confirm}
          icon={IconClockExclamation}
        />
      </KPISubgroup>

      <KPISubgroup title="CRM — Atendimento e Pipeline" icon={IconUsers} color="#a855f7">
        <KPICard
          label="Sessões Abandonadas"
          kpi={k.sessions_abandoned}
          icon={IconMoodSad}
          color="linear-gradient(135deg, #f59e0b, #d97706)"
          hint="Cliente desistiu de esperar atendimento"
        />
        <KPICard
          label="Taxa de Transferência"
          kpi={k.transfer_rate}
          icon={IconArrowsExchange}
          hint="IA → atendente humano"
        />
        <KPICard
          label="Deals Perdidos"
          kpi={k.lost_deals}
          icon={IconBan}
        />
        <KPICard
          label="Deals Estagnados"
          kpi={k.stagnant_deals}
          icon={IconHourglassEmpty}
          hint="Mais de 30 dias na mesma coluna 'aberta'"
        />
      </KPISubgroup>

      {pareto?.categories?.length > 0 ? (
        <div className="insights-chart">
          <div className="insights-chart__head"><h3>Motivos de perda (Pareto)</h3></div>
          <InsightsChart
            type="bar"
            categories={pareto.categories || []}
            series={pareto.series || []}
            colors={["#ef4444"]}
            extra={{ plotOptions: { bar: { horizontal: true, distributed: false } } }}
          />
        </div>
      ) : (
        <div className="insights-chart insights-chart--empty">
          <p>
            Nenhum motivo de perda registrado no período.
            Use o campo <strong>"Motivo"</strong> ao mover contatos para colunas tipo "Perdido"
            para ter um Pareto acionável aqui.
          </p>
        </div>
      )}
    </BlockSection>
  );
};

export default BottlenecksBlock;
